import apiInstance from '../../../backend-api.setup'
import { ApiPathConfig } from '../../../../config/ApiPathConfig'

const getPrivateReportsService = ({
  ordering,
  page_size = 50,
  query,
}: {
  ordering?: string
  page_size?: number
  query?: string
}) => {
  return apiInstance.get(ApiPathConfig.PRIVATE_REPORTS, {
    params: {
      ordering,
      page_size,
      query,
    },
  })
}

export default getPrivateReportsService
